import { Box } from "@mui/material";

import EventsTable from "~/features/serviceSupport/eventsMonitor/EventsTable";
import { useNavbar, ViewNameTranslation } from "~/hooks/useNavbar";

const VIEW_TITLE: ViewNameTranslation = "nav.viewname.service support events";

export function EventTablePreview() {
  useNavbar({ viewTitle: VIEW_TITLE });

  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        boxSizing: "border-box"
      }}
    >
      <EventsTable />
    </Box>
  );
}
